module.exports = __webpack_public_path__ + "assets/img/fashion-img2-f010fc69.png";